import type { Components } from 'react-markdown';
import { renderBlockFence } from '@/components/block-primitives/block-fence-registry';
import { instructionBlockRegistry } from '../../agent-blocks/agent-block-registry';

const instructionFencePreview = (source: string): Components['pre'] => {
  return ({ node, children }) => {
    const position = node?.position;
    const start = position?.start.offset;
    const end = position?.end.offset;
    if (position?.start.column !== 1 || start === undefined || end === undefined) {
      return <pre className="whitespace-pre-wrap">{children}</pre>;
    }

    const lines = source.slice(start, end).split(/\r?\n/);
    const opening = /^(`{3,}|~{3,})[ \t]*agent-v1:(checklist|procedure)[ \t]*$/.exec(lines[0] ?? '');
    const closing = /^[ ]{0,3}(`{3,}|~{3,})[ \t]*$/.exec(lines.at(-1) ?? '');
    if (!opening || !closing || opening[1][0] !== closing[1][0] || closing[1].length < opening[1].length) {
      return <pre className="whitespace-pre-wrap">{children}</pre>;
    }

    const block = renderBlockFence(instructionBlockRegistry, opening[2], lines.slice(1, -1).join('\n'), {
      editable: false,
      onChange: () => {},
      onDelete: () => {},
    });
    return block ?? <pre className="whitespace-pre-wrap">{children}</pre>;
  };
};

export default instructionFencePreview;
